import { useState } from "react";
import { Upload, X, Loader2 } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;

export default function ImageUploader({ value, onChange, auth }) {
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState(null);

  const handleFileSelect = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    // Reset
    setError(null);
    setUploading(true);

    try {
      // Upload file directly
      const formData = new FormData();
      formData.append("file", file);

      const response = await fetch(`${API}/api/upload`, {
        method: "POST",
        headers: {
          Authorization: `Basic ${btoa(`${auth.username}:${auth.password}`)}`,
        },
        body: formData,
      });

      if (!response.ok) {
        const err = await response.json().catch(() => ({}));
        throw new Error(err.detail || "Erreur lors de l'upload");
      }

      const data = await response.json();
      
      // Set the base64 data URL directly
      onChange(data.url);
      
    } catch (err) {
      console.error("Upload error:", err);
      setError(err.message || "Erreur lors de l'upload");
    } finally {
      setUploading(false);
    }

    // Reset input
    e.target.value = "";
  };

  const handleRemove = () => {
    onChange("");
    setError(null);
  };

  return (
    <div className="space-y-3">
      {/* Error message */}
      {error && (
        <div className="bg-red-50 text-red-600 p-3 rounded-lg text-sm">
          {error}
        </div>
      )}

      {/* Image Preview */}
      {value && (
        <div className="relative inline-block">
          <div className="w-32 h-32 rounded-lg overflow-hidden border bg-gray-100">
            <img
              src={value}
              alt="Aperçu"
              className="w-full h-full object-cover"
            />
          </div>
          {!uploading && (
            <button
              type="button"
              onClick={handleRemove}
              className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full p-1 hover:bg-red-600 shadow-md"
            >
              <X className="h-4 w-4" />
            </button>
          )}
        </div>
      )}

      {/* Upload Button */}
      <div>
        <label className="cursor-pointer inline-block">
          <input
            type="file"
            accept="image/jpeg,image/jpg,image/png,image/webp,image/gif"
            onChange={handleFileSelect}
            className="hidden"
            disabled={uploading}
          />
          <div className={`flex items-center gap-2 px-4 py-2 border border-dashed rounded-lg transition-colors ${
            uploading 
              ? "border-gray-200 bg-gray-50 cursor-not-allowed" 
              : "border-gray-300 hover:border-primary hover:bg-primary/5 cursor-pointer"
          }`}>
            {uploading ? (
              <>
                <Loader2 className="h-5 w-5 text-gray-400 animate-spin" />
                <span className="text-sm text-gray-400">Upload en cours...</span>
              </>
            ) : (
              <>
                <Upload className="h-5 w-5 text-gray-500" />
                <span className="text-sm text-gray-600">
                  {value ? "Changer l'image" : "Importer une image"}
                </span>
              </>
            )}
          </div>
        </label>
      </div>

      <p className="text-xs text-gray-500">
        Formats acceptés : JPG, PNG, WEBP, GIF (max 10 Mo)
      </p>
    </div>
  );
}
